import handgirl from "../../../Assets/Img/handgirl.webp";
import focus from "../../../Assets/Img/focus.webp";
import reviews from "../../../Assets/Img/reviews.webp";
import rightpartner from "../../../Assets/Img/rightpartner.webp";
import ease from "../../../Assets/Img/ease.jpeg";
import stock from "../../../Assets/Img/stock.webp";
import support from "../../../Assets/Img/support.webp";
import founder from "../../../Assets/Img/founder.webp";
import motivated from "../../../Assets/Img/motivated.webp";
import ongoing from "../../../Assets/Img/ongoing.jpeg";
import { Breadcrumb } from "antd";
import Data from "./Data";
import Reasonpicked from "../../../subComponent/Reasonpicked";
import NavBar from "../../../subComponent/NavBar";


const Partner = () => {
    return (
        <>

            <div className="background-setting partner-background">
            <NavBar />
                <div className="container">
                    
                    <div className="position-relative pargraph-line mx-auto pt-5 ">
                        <p className=" text-center  text-white poppins fs_30 fw-500 ls_3 ">
                            Why Work With SmartB
                        </p>
                        <div className="gradient-line"></div>
                    </div>
                    <p className="text-white text-center m-0 py-4">Finding the Right Partner</p>
                    <div className="contact-us-image Rounded-6  mx-0 mx-md-5  p-0 p-md-5  ">
                        <img src={rightpartner} width="100% m-0" alt="Your image" />
                    </div>
                    <div className="text-center  mx-2 mx-md-0 my-3 my-md-5">
                        <p class=" underline-with-circle-and-dot reviews-underline poppins text-white  fs_30 ls_2 ">A Message From The Company Founder</p>
                    </div>
                </div>
                {/* section-1 */}

                <Reasonpicked data={Data} />
      <div className="py-5">
                    <div className="row reviews-wrapper mx-0 mx-md-5  py-5 ">
                        <div className="col-12 col-md-5">
                        </div>
                        <div className="col-12 col-md-7">
                            <div className="position-relative  pargraph-line reviews-content mx-auto">
                                <p className=" text-center  text-white poppins fs_30 fw-500 ls_3 ">
                                    Customers love our system for different reasons...
                                </p>
                                <div className="gradient-line"></div>
                            </div>

                        </div>
                        <div className="review-image col-12 col-md-5 py-3">
                            <img src={reviews} width="100%" alt="Youe Image"></img>
                        </div>
                        <div className="col-12 col-md-7  d-flex justify-content-center align-items-center flex-column">
                            <p className="text-white reviews-descrption text-center poppins ls_20 ls_3">
                                It was a pleasure to work with SmartB. The system is easy to use and the project went well as the implementation was quick and smooth.
                            </p>
                          <div className="rating">
                        <button className="rating__star review__star">★</button>
                        <button className="rating__star review__star">★</button>
                        <button className="rating__star review__star">★</button>
                        <button className="rating__star review__star">★</button>
                        <button className="rating__star review__star">★</button>
                        <button className="rating__star review__star">★</button>
                      

                    </div>
                    
                        </div>
                      <div className="col-5 col-12">
                      </div>
                      <div className="col-7 col-12">
                      </div>
                    </div>
                    
                </div>

            </div>
      
        </>
    )

}
export default Partner